import { useState } from "react";
import { ThumbsUp, ThumbsDown, Check } from "lucide-react";
import { sendSessionSurvey } from "../../lib/api";

const Choice = ({ icon: Icon, label, onClick, testid }) => (
  <button onClick={onClick} data-testid={testid} className="flex-1 flex items-center justify-center gap-2 border border-[#D1CFC7] bg-[#FAF9F6] hover:border-[#2C402E] hover:text-[#2C402E] py-3 font-body text-sm transition-colors">
    <Icon size={16} /> {label}
  </button>
);

export const ReadingSurvey = ({ sessionId, sponsor }) => {
  const storeKey = `cled_survey_${sessionId}`;
  const [step, setStep] = useState(() => sessionStorage.getItem(storeKey) || "pleasant");
  const go = (next) => { setStep(next); sessionStorage.setItem(storeKey, next); };

  const answer = (field, value) => {
    sendSessionSurvey(sessionId, { [field]: value });
    go(field === "pleasant" && sponsor ? "partner" : "done");
  };

  return (
    <section data-testid="reading-survey" className="mt-14 bg-[#F4F1EA] border border-[#E8E4D9] p-6 text-center">
      {step === "pleasant" && (
        <>
          <p className="font-serif text-xl text-[#1A1A1A] mb-5">Cette pause lecture a-t-elle rendu votre moment plus agréable&nbsp;?</p>
          <div className="flex gap-3">
            <Choice icon={ThumbsUp} label="Oui" onClick={() => answer("pleasant", true)} testid="survey-pleasant-yes" />
            <Choice icon={ThumbsDown} label="Non" onClick={() => answer("pleasant", false)} testid="survey-pleasant-no" />
          </div>
        </>
      )}
      {step === "partner" && sponsor && (
        <>
          <p className="font-serif text-xl text-[#1A1A1A] mb-5">Cette lecture offerte par <em className="text-[#2C402E]">{sponsor.name}</em> améliore-t-elle l'image que vous avez de cet établissement&nbsp;?</p>
          <div className="flex gap-3">
            <Choice icon={ThumbsUp} label="Oui" onClick={() => answer("partner_positive", true)} testid="survey-partner-yes" />
            <Choice icon={ThumbsDown} label="Non" onClick={() => answer("partner_positive", false)} testid="survey-partner-no" />
          </div>
        </>
      )}
      {step === "done" && (
        <p data-testid="survey-thanks" className="flex items-center justify-center gap-2 font-serif italic text-lg text-[#2C402E]"><Check size={18} /> Merci pour votre avis&nbsp;!</p>
      )}
    </section>
  );
};
